import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";

function handleRequest(
  state: State,
  { document }: Boundaries["updateDocument"]["request"],
): State {
  const index = state.findIndex((req) => req.document.uuid === document.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { document, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { document }: Boundaries["updateDocument"]["success"],
): State {
  const index = state.findIndex((req) => req.document.uuid === document.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { document, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { document, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { document }: Boundaries["updateDocument"]["failure"],
): State {
  const index = state.findIndex((req) => req.document.uuid === document.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToFailure(),
        },
        ...state.slice(index + 1),
      ]
    : [...state, { document, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.updateDocumentRequested]: handleRequest,
    [events.updateDocumentSucceeded]: handleSuccess,
    [events.updateDocumentFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
